// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n[dir] .fade-enter, [dir] .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\n  -webkit-transform: translateY(-20px);\n          transform: translateY(-20px);\n}\n/* .h-345 .card {\n  min-height: 345px;\n} */\n", ""]);
// Exports
module.exports = exports;
